import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/min/moment-with-locales';
import { FormattedDate, FormattedTime, FormattedMessage } from 'react-intl';
import styles from './additionalInfo.module.scss';

import Collapsible from '../../../../../components/collapsible/Collapsible';

const AdditionalInformation = ({ answer, fields, active }) => {
  const renderWeatherObs = obs => (obs !== undefined ? `${obs.metar.summary} - ${obs.metar.temperature}${obs.metar.wind !== undefined ? `, ${obs.metar.wind}` : ''}${obs.metar.humidity !== undefined ? `, Humidity - ${obs.metar.humidity}` : ''}` : '');
  const renderInfoForType = (field, value) => {
    switch (field.type) {
      case 'date':
        return <FormattedDate value={moment(value)} />;
      case 'datetime':
        return (
          <>
            <FormattedDate value={moment(value)} />
            {' @ '}
            <FormattedTime value={moment(value)} />
          </>
        );
      case 'string':
        return <div>{value}</div>;
      case 'dataSource':
        return <div>{value}</div>;
      case 'dataSourceMultiselect':
        return value && value.map(val => (
          <div key={val}>{val}</div>
        ));
      case 'select': {
        const f = answer.version.schema.fields.find(e => e.id === field.id);
        return (
          <div>{f.values.find(e => e.key === value).value}</div>
        );
      }
      case 'multiselect': {
        const f = answer.version.schema.fields.find(e => e.id === field.id);
        return value.map(val => (
          <div key={val}>{f.values.find(e => e.key === val).value}</div>
        ));
      }
      default:
        return null;
    }
  };

  return (
    <Collapsible openOnMount={active} title="inspections.answer_details.additionalInfo" styleClasses={styles.addInfo}>
      <div className={styles.additionalInfo}>
        {Object.keys(fields).map(k => (
          <div key={fields[k].id} className={styles.field}>
            <span className={styles.title}>{fields[k].title}</span>
            <div className={styles.info}>
              {answer.response[k] && renderInfoForType(fields[k], answer.response[k])}
            </div>
          </div>
        ))}
        <div key="weather_obs" className={styles.field}>
          <span className={styles.title}><FormattedMessage id="inspections.answer_details.weatherobservation" defaultMessage="Weather Observations" /></span>
          <div dangerouslySetInnerHTML={{ __html: renderWeatherObs(answer.weather_conditions.current_obs) }} className={styles.info} />
        </div>
      </div>
    </Collapsible>
  );
};

AdditionalInformation.propTypes = {
  answer: PropTypes.shape({}).isRequired,
  fields: PropTypes.shape({}).isRequired
};
export default AdditionalInformation;
